export default __webpack_public_path__ + "static/media/eco_img_04.754f4564.png";